import { render, staticRenderFns } from "./ItemAuthorizedPerson.vue?vue&type=template&id=9577f1fe&"
import script from "./ItemAuthorizedPerson.vue?vue&type=script&lang=ts&"
export * from "./ItemAuthorizedPerson.vue?vue&type=script&lang=ts&"
import style0 from "./ItemAuthorizedPerson.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRow,VSheet,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9577f1fe')) {
      api.createRecord('9577f1fe', component.options)
    } else {
      api.reload('9577f1fe', component.options)
    }
    module.hot.accept("./ItemAuthorizedPerson.vue?vue&type=template&id=9577f1fe&", function () {
      api.rerender('9577f1fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/access/ItemAuthorizedPerson.vue"
export default component.exports